import { Record } from 'immutable';
import { CONTENT_UPDATE } from './actions';

const PLUS_CONTENT_API_KEY = 'plusApi';

export const InitialState = new Record({
  plusApi: {}
});

export default (state = new InitialState(), action) => {
  const { type, data } = action;

  switch (type) {
    case CONTENT_UPDATE: {
      return state.set(PLUS_CONTENT_API_KEY, data);
    }

    default:
      return state;
  }
};
